/*
	Las horas se dicen como las dice la gente: "6:39 am", "1:43 pm", sin el cero de adelante
	ni el formato de 24 h (Esteban, 2026-09-23). El espacio antes del am/pm es duro para que
	una columna estrecha no parta "1:43" de su "pm".
*/
export const horaDoce = (hhmm: string | null | undefined): string => {
	const m = String(hhmm || "").match(/^(\d{1,2}):(\d{2})/);
	if (!m) {
		return String(hhmm || "");
	}
	const h = parseInt(m[1], 10);
	const docena = h % 12 === 0 ? 12 : h % 12;
	return `${docena}:${m[2]}\u00A0${h < 12 ? "am" : "pm"}`;
};

/** "2026-09-05T13:09" (API local time) -> "05/09/2026 1:09 pm"; "2026-09-05" -> "05/09/2026". */
export const formatLocalDateTime = (value: string | null | undefined): string => {
	if (!value) {
		return "-";
	}
	const [datePart, timePart] = value.split("T");
	const pieces = datePart.split("-");
	if (pieces.length !== 3) {
		return value;
	}
	const date = `${pieces[2]}/${pieces[1]}/${pieces[0]}`;
	return timePart ? `${date} ${horaDoce(timePart)}` : date;
};

export const formatPercentage = (value: number | null | undefined): string => {
	if (value === null || value === undefined || isNaN(value)) {
		return "";
	}
	return `${Number.isInteger(value) ? value : value.toFixed(2).replace(/\.?0+$/, "")}%`;
};
